<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="width: 700px; height: 500px;" #modalBody>
  <app-media-swiper [mediaItems]="images" [index]="index"></app-media-swiper>
</div>
